import React from 'react';
import ToggleSwitch from './ToggleSwitch';

const InputControls = ({ clients, setClients, fullEngagements, setFullEngagements }) => {
  const min = 1;
  const max = 10;
  const percentage = ((clients - min) / (max - min)) * 100;

  return (
    <div className="flex flex-col justify-center bg-[#0A1128] p-6 sm:p-8 rounded-lg border border-[#1a2238]">

      {/* Slider Section */}
      <div className="mb-2">
        <div className="flex justify-between items-end mb-5">
          <label htmlFor="clients" className="text-xs font-bold uppercase tracking-widest text-slate-400 font-inter">
            New Clients Per Month
          </label>
          <span
            className="text-4xl font-oswald text-[#00E5FF] font-bold leading-none"
            style={{ textShadow: '0 0 16px rgba(0,229,255,0.5)' }}
          >
            {clients}
          </span>
        </div>

        {/* Custom Styled Range Slider */}
        <div className="relative w-full">
          <input
            id="clients"
            type="range"
            min={min}
            max={max}
            step="1"
            value={clients}
            onChange={(e) => setClients(parseInt(e.target.value, 10))}
            className="w-full h-2 rounded-full appearance-none cursor-pointer outline-none focus:outline-none"
            style={{
              background: `linear-gradient(to right, #00E5FF 0%, #00E5FF ${percentage}%, #1a2238 ${percentage}%, #1a2238 100%)`,
            }}
          />
        </div>

        <div className="flex justify-between text-[10px] text-slate-600 mt-3 font-mono tracking-widest uppercase">
          <span>1 Min</span>
          <div className="flex gap-1">
            {Array.from({ length: 10 }, (_, i) => (
              <span
                key={i + 1}
                className={`w-1 h-1 rounded-full inline-block mt-1 ${
                  i + 1 <= clients ? 'bg-[#00E5FF]' : 'bg-[#1a2238]'
                }`}
              />
            ))}
          </div>
          <span>10 Max</span>
        </div>
      </div>

      <ToggleSwitch
        checked={fullEngagements}
        onChange={setFullEngagements}
        label="Include Full Remediation Engagements?"
      />

      {/* Rate Info */}
      <div className="mt-6 p-4 bg-[#060c1a] rounded border border-[#1a2238]">
        <div className="flex justify-between items-center mb-2">
          <span className="text-[10px] uppercase tracking-widest text-slate-500 font-mono">Active Rate</span>
          <span className={`text-xs font-mono font-bold ${fullEngagements ? 'text-[#00E5FF]' : 'text-slate-300'}`}>
            {fullEngagements ? 'FULL ENGAGEMENT' : 'BASE AUDIT'}
          </span>
        </div>
        <div className="flex justify-between items-end">
          <span className="text-xs text-slate-500 font-mono">Per Client Value</span>
          <span className="text-xl font-mono font-bold text-white">
            {fullEngagements
              ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(11250)
              : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(4750)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InputControls;